import { useRoles } from './UserContextProvider.store';

export function useHasRole(role: string): boolean {
  const roles = useRoles();
  return roles.includes(role);
}

export function useHasAnyRole(...targetRoles: string[]): boolean {
  const roles = useRoles();
  return targetRoles.some((r) => roles.includes(r));
}
